import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'token'

async function postLogin(login) {
    try {
        var data = await ServiceBase.postData(endpoint, login)
        return data;
    } catch (e) {
        throw e;
    }
}

export const LoginService = {
    postLogin
}